
import { Component, Vue } from "vue-property-decorator";
import { ChangePasswordVO, MypageOVO } from '@/views/biz/mypage/vo/mypage.vo'
import axios from 'axios';
import CommonUtils from "@/common-utils";

@Component
export default class ChangePassword extends Vue {
  password: ChangePasswordVO = {} as ChangePasswordVO;
  member: MypageOVO = {} as MypageOVO;

  checkPassword = '';

  // 변경
  save() {
    if(CommonUtils.validatePassword(this.password.newPassword) == false) {
      // 비밀번호는 영어와 숫자 조합으로 8자 이상 16자 이하로 입력해야 합니다.
      return alert(this.$t('member-info.a0007').toString());
    }

    if(this.password.newPassword != this.checkPassword) {
      // 비밀번호가 일치하지 않습니다.
      return alert(this.$t('member-info.a0005').toString());
    }

    if(confirm(this.$t('common.c0002').toString())) {
      axios.put('/mypage/profile/password', this.password)
      .then(r=>{
        if(r.data) {
          // 비밀번호가 변경되었습니다.
          alert(this.$t('member-info.a0018'));
          this.$router.push({name: 'MypageProfile'})
        }
      })
    }
  }

  created(): void {
    axios.get('/member')
    .then(r=>{
      this.member = r.data;
    })
  }

}
